import { Add } from '@mui/icons-material';
import { Stack, SvgIcon, Typography, Paper, ClickAwayListener } from '@mui/material';
import { FunctionComponent, useRef, useState } from 'react';
import { StyledFloatingActionButton } from '../styles';

interface IFloatingAddLogProps {
  renderActions: (onClose: () => void) => JSX.Element;
  disabled?: boolean;
}

const FloatingAddLog: FunctionComponent<IFloatingAddLogProps> = ({
  renderActions,
  disabled = false,
}) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      {open && buttonRef.current && (
        <ClickAwayListener onClickAway={handleClose}>
          <Paper
            elevation={4}
            sx={{
              position: 'fixed',
              bottom: `calc(16px + ${buttonRef.current.offsetHeight}px + 8px)`, // dodajemo +8px za strelicu
              right: '16px',
              width: 300,
              maxHeight: '60vh',
              overflowY: 'auto',
              zIndex: 1300,
              px: 1,
              py: 1,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {renderActions(handleClose)}
          </Paper>
        </ClickAwayListener>
      )}

      <StyledFloatingActionButton
        ref={buttonRef}
        type="button"
        onClick={handleOpen}
        disabled={disabled}
        color="primary"
      >
        <Stack alignItems="center" flexDirection="row">
          <Typography variant="caption">Enter log</Typography>
          <SvgIcon component={Add} />
        </Stack>
      </StyledFloatingActionButton>
    </>
  );
};

export default FloatingAddLog;
